/* =====================================================================
   UUGI v4 — Interactions
   ===================================================================== */

$(function () {

  /* ---------- Loader ---------- */
  $(window).on('load', function () {
    setTimeout(function () { $('#loader').addClass('is-gone'); }, 400);
  });
  setTimeout(function () { $('#loader').addClass('is-gone'); }, 2200);


  /* ---------- Navbar scroll state ---------- */
  var $nav = $('#nav');
  function onScroll() {
    if ($(window).scrollTop() > 30) $nav.addClass('is-scrolled');
    else $nav.removeClass('is-scrolled');
  }
  $(window).on('scroll', onScroll);
  onScroll();


  /* ---------- Smooth anchor scroll ---------- */
  $('a[href^="#"]').on('click', function (e) {
    var t = $(this).attr('href');
    if (t.length < 2) return;
    var $tgt = $(t);
    if (!$tgt.length) return;
    e.preventDefault();
    $('html, body').animate({ scrollTop: $tgt.offset().top - 60 }, 700, 'swing');
  });


  /* ---------- Scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $('.reveal').addClass('is-visible');
  }


  /* ---------- Counters (hero + India strip + MVPs) ----------
     Trust strip counters live in trust-strip.js — they run on scroll-in. */
  function animateCounter($el, target, dur) {
    dur = dur || 1800;
    var start = performance.now();
    function tick(now) {
      var t = Math.min(1, (now - start) / dur);
      var eased = 1 - Math.pow(1 - t, 3);
      $el.text(Math.floor(eased * target).toLocaleString('en-IN'));
      if (t < 1) requestAnimationFrame(tick);
      else $el.text(target.toLocaleString('en-IN'));
    }
    requestAnimationFrame(tick);
  }
  var countersRun = false;
  function runCounters() {
    if (countersRun) return;
    countersRun = true;
    $('.stat strong').each(function () {
      var target = parseInt($(this).attr('data-count'), 10) || 0;
      animateCounter($(this), target);
    });
  }
  setTimeout(runCounters, 800);


  /* ---------- Hero parallax ---------- */
  $(window).on('mousemove', function (e) {
    var x = e.clientX / window.innerWidth - 0.5;
    var y = e.clientY / window.innerHeight - 0.5;
    $('.hero__sun-glow').css('transform', 'translate(' + (x * 12) + 'px, ' + (y * 12) + 'px)');
    $('.hero__collage').css('transform', 'translate(' + (x * -6) + 'px, ' + (y * -6) + 'px)');
    $('.ph--1').css('transform', 'translate(' + (x * 4) + 'px, ' + (y * 4) + 'px)');
    $('.ph--2').css('transform', 'translate(' + (x * -3) + 'px, ' + (y * -3) + 'px)');
  });

  // Scroll parallax
  $(window).on('scroll', function () {
    var s = $(window).scrollTop();
    if (s < window.innerHeight) {
      $('.hero__sun').css('transform', 'rotate(' + (s * 0.05) + 'deg)');
    }
  });


  /* ---------- FAQ — close others on open ---------- */
  $('.faq-item').on('toggle', function () {
    if (this.open) {
      $('.faq-item').not(this).each(function () { this.open = false; });
    }
  });


  /* ---------- Journey scrollytelling ---------- */
  var $steps  = $('.journey__steps .step');
  var $scenes = $('.journey__pin .scene');
  var $rail   = $('.journey__rail-track span');

  function setActiveStep(idx) {
    $steps.removeClass('is-active').eq(idx).addClass('is-active');
    $scenes.removeClass('is-active').eq(idx).addClass('is-active');
    $rail.removeClass('is-active').eq(idx).addClass('is-active');
  }

  if ($steps.length && 'IntersectionObserver' in window) {
    var stepObserver = new IntersectionObserver(function (entries) {
      var best = null;
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var rect = entry.boundingClientRect;
          var dist = Math.abs((rect.top + rect.height / 2) - window.innerHeight / 2);
          if (!best || dist < best.dist) best = { el: entry.target, dist: dist };
        }
      });
      if (best) {
        var i = $steps.index(best.el);
        if (i >= 0) setActiveStep(i);
      }
    }, { rootMargin: '-40% 0px -40% 0px', threshold: 0 });
    $steps.each(function () { stepObserver.observe(this); });
  }


  /* ---------- Past events filter ---------- */
  $('.past__filters .chip').on('click', function () {
    var $btn = $(this);
    var f = $btn.attr('data-filter');
    $('.past__filters .chip').removeClass('is-active').attr('aria-pressed', 'false');
    $btn.addClass('is-active').attr('aria-pressed', 'true');

    $('.event').each(function (i) {
      var $card = $(this);
      var type = $card.attr('data-type');
      if (f === 'all' || type === f) {
        $card.removeClass('is-hidden');
        $card.css({ opacity: 0, transform: 'translateY(14px)' });
        setTimeout(function () {
          $card.css({ opacity: 1, transform: 'translateY(0)', transition: 'opacity .5s, transform .5s' });
        }, i * 55);
      } else {
        $card.css({ opacity: 0, transform: 'translateY(8px)' });
        setTimeout(function () { $card.addClass('is-hidden'); }, 350);
      }
    });
  });


  /* ---------- Mobile nav drawer: see js/nav.js ---------- */


  /* ---------- Active nav link on scroll ---------- */
  var navMap = {
    'education':  '#join-cta',
    'about':      '#umbraco',
    'community':  '#story',
    'faq':        '#faq',
    'contact':    '#contact'
  };
  var navSections = [];
  Object.keys(navMap).forEach(function (key) {
    var $s = $(navMap[key]);
    if ($s.length) navSections.push({ key: key, top: $s.offset().top, height: $s.outerHeight() });
  });
  function setActiveNav() {
    var y = $(window).scrollTop() + 120;
    var current = null;
    navSections.forEach(function (s) {
      if (y >= s.top && y < s.top + s.height) current = s.key;
    });
    $('.nav__link').removeClass('is-active');
    if (current) $('.nav__link[data-nav="' + current + '"]').addClass('is-active');
  }
  $(window).on('scroll resize', setActiveNav);
  setTimeout(setActiveNav, 400);


  /* ---------- Footer newsletter ---------- */
  $('.footer__news').on('submit', function (e) {
    e.preventDefault();
    var $btn = $(this).find('button');
    var orig = $btn.text();
    $btn.text('Thanks ✓');
    $(this).find('input').val('');
    setTimeout(function () { $btn.text(orig); }, 2400);
  });

});
